module.exports = function getResource(label, vars = []) {
    const resources = {
        please: 'Veuillez',
        signIn: 'ouvrir une session',
        review: 'pour consulter cette rubrique.'
    };

    return resources[label];
};
